export default __webpack_public_path__ + "locales/es/DeleteSelfProfileDialog.json?hash=8dc4a40cb426b4693ac6e77a2206db64";